import React from 'react';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import PageHeading from 'src/components/common/page-heading';
import MeshulamForm from './components/meshulam-form';
import PaymentForm from './components/payment-form';
import PaymentInfo from './components/payment-info';

import cartStore from 'src/stores/cart-store';
import globalStore from 'src/stores/global-store';

import { AppRoute, IS_MESHULAM_PAYMENT, LOCALES } from 'src/constants';

import './payment-page.scss';

const PaymentPage = observer(() => {
  const { decedent, queryParams } = globalStore;

  if (!cartStore.clientInfo) {
    return <Navigate to={`${AppRoute.CHECKOUT_PAGE_ROUTE}?${queryParams}`} />;
  }

  return (
    <div className="payment-page">
      <PageHeading
        decedent={decedent}
        description={LOCALES.ENTER_CARD_INFO}
        isHideDecedentOnDesktop
        step={3}
        title={LOCALES.PAYMENT}
      />
      <div className="payment-page__content">
        <PaymentInfo />
        {IS_MESHULAM_PAYMENT ? <MeshulamForm /> : <PaymentForm />}
      </div>
    </div>
  );
});

export default PaymentPage;
